"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("material-ui/Dialog"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function NewShareToSocialMedia(props) {
  var _React$createElement;
  return window.innerWidth >= 768 ? /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (_React$createElement = {
    contentStyle: {
      width: 300,
      maxWidth: 'none'
    },
    title: props.title
    //  actions ={actions}
    // bodyStyle={{ backgroundColor: "white", width:  "511px", height:"622px !important", padding:'20px',borderRadius:'0px 0px  4px 4px' }}
  }, _defineProperty(_React$createElement, "contentStyle", {
    backgroundColor: "white",
    width: "511px",
    maxHeight: '622px'
  }), _defineProperty(_React$createElement, "bodyStyle", {
    backgroundColor: "white",
    width: "522px",
    maxHeight: "622px"
  }), _defineProperty(_React$createElement, "modal", true), _defineProperty(_React$createElement, "open", props.open), _defineProperty(_React$createElement, "onRequestClose", props.handleCloseDialog), _defineProperty(_React$createElement, "autoScrollBodyContent", true), _React$createElement), /*#__PURE__*/_react["default"].createElement(NewShareToSocialMediaChildrenComponent, props)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "mg-modal centre view-share-modal-div " + (props.open ? 'displayBlock' : 'displayNone')
  }, /*#__PURE__*/_react["default"].createElement(NewShareToSocialMediaChildrenComponent, props));
}
function NewShareToSocialMediaChildrenComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-header-div"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-header-div-content"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "share-header-div-content-header"
  }, props.i18next.t("lable.Share")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "share-header-div-content-subheader"
  }, props.i18next.t("lable.selectToPostTo"))), /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-times close-icon",
    "data-e2e": "close",
    onClick: props.shareModal_close
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-social-media-div"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-social-media-icon-div",
    onClick: props.shareOnFacebook
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-facebook-f fa-lg"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "social-media-name"
  }, props.i18next.t("lable.facebook")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-social-media-icon-div",
    onClick: props.shareOnTwitter
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-twitter fa-lg"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "social-media-name"
  }, props.i18next.t("lable.twitter")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-social-media-icon-div-or"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-social-media-icon-div-line"
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.i18next.t("lable.or")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-social-media-icon-div-line"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-e2e": "linkCopy",
    className: "share-social-media-icon-div " + (props.copiedLink !== "" ? "share_copyLink_disable" : ""),
    onClick: function onClick() {
      props.setCopiedLink(props.shareLink);
      (0, _copyToClipboard["default"])(props.shareLink);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-lg fa-copy"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, " ", props.copiedLink !== "" ? props.i18next.t("lable.linkCopied") : props.i18next.t("lable.copyLink"))))));
}
var _default = NewShareToSocialMedia;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/NewShareToSocialMedia.js
 ** module id = 2392
 ** module chunks = 0
 **/